export const TELEHEALTH_PROCEDURES = {
  10002062: '50000462', // psicologia
  10002063: '50000560', // nutricionista
  10002064: '10101012 - 225125', // clinico geral,
  10002082: '50000470', // sessão individual de psicoterapia
  10002083: '50001183', // sessão individual de psicologia
  10002090: '10000761', // ginecologista
  10002093: '10101012 - 225133', // psiquiatra
  10002137: '50000586', // Fonoaudiologista
  10002138: '10000661', // Fonoaudiologista pacote sessões 10
  10002139: '10000660', // Fonoaudiologista pacote sessões 04
  10002202: '10101012 - 225120',
  10002322: '10101012 - 225285', // urologia
} as Record<number | string, string>;
